"use strict";
var applyContainerQuery_1 = require('./applyContainerQuery');
module.exports = {
    applyContainerQuery: applyContainerQuery_1.default,
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-container-query/lib/index.js
 ** module id = 423
 ** module chunks = 0
 **/